import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledTaskCard = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'light' ? theme.palette.grey[200] : theme.palette.grey[800],
  padding: theme.spacing(6),
  border: '1px solid',
  borderColor: theme.palette.mode === 'light' ? theme.palette.grey[300] : theme.palette.grey[700],
  boxShadow: theme.customShadows.boxShadow,
  borderRadius: 12,
  height: 'fit-content',
}));
